import React, {memo} from 'react';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUITypography from '@/components/MUI-Components/MUI-Typography';

const PerfectBlockchain = (props: any) => {
    const {perfectBlockchainData, heading, className, marginclass, headingSx} = props;
    return (
        <MUIBox>
            <MUITypography className={`challenge-heading ${className} ${marginclass} margin`} sx={headingSx}>
                {heading}{' '}
            </MUITypography>
            <MUIBox className="divder-wrapper perfect-blockchain-divider-wrapper">
                <hr className="divider-line top-spacing divider-margin" />
            </MUIBox>
            {perfectBlockchainData?.map((data: any, index: any) => (
                <MUIBox key={index}>
                    <MUITypography className="blockchain-para">{data}</MUITypography>
                </MUIBox>
            ))}
        </MUIBox>
    );
};
export default memo(PerfectBlockchain);
